module.exports = __webpack_public_path__ + "static/media/editIcon.5b189444.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/editIcon.svg
// module id = 856
// module chunks = 0